import type { Canale } from '@offertify/core';

export type { Canale };

export const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

export const DEFAULT_CANALE_COLOR = '#2563eb';

export const CANALE_PALETTE: string[] = [
  '#ef4444',
  '#f97316',
  '#f59e0b',
  '#eab308',
  '#84cc16',
  '#22c55e',
  '#10b981',
  '#14b8a6',
  '#06b6d4',
  '#3b82f6',
  '#6366f1',
  '#8b5cf6',
  '#a855f7',
  '#ec4899',
  '#6b7280',
];
